import { getOnecomConfig, getVoucherCode } from "store/selectors";
import { getNormalizedCartItems } from "../../utils";

const addShippingInfo = () => (dispatch, getState) => {
  const state = getState();
  const coupon = getVoucherCode(state);
  const items = getNormalizedCartItems(state);
  const { currency } = getOnecomConfig(state) || {};
  window.GTM.pushAddShippingInfo({ coupon, items, currency });
};

export default addShippingInfo;
